import { MediaQueries } from 'UI'

export default {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: ({ containerMarginBottom }) => containerMarginBottom || null,
    gap: ({ rowGap, columnGap }) => `${rowGap}px ${columnGap}px`
  },
  [`${MediaQueries.desktop}`]: {
    container: {
      marginBottom: ({ containerMarginBottomDesktop }) => containerMarginBottomDesktop || null,
      gap: ({ rowDesktopGap, columnDesktopGap }) => `${rowDesktopGap}px ${columnDesktopGap}px`
    }
  },
  [`${MediaQueries.tablet}`]: {
    container: {
      marginBottom: ({ containerMarginBottomTablet }) => containerMarginBottomTablet || null,
      gap: ({ tabletRowGap, tabletColumnGap }) => `${tabletRowGap}px ${tabletColumnGap}px`
    }
  },
  [`${MediaQueries.mobile}`]: {
    container: {
      marginBottom: ({ containerMarginBottomMobile }) => containerMarginBottomMobile || null,
      gap: ({ mobileRowGap, mobileColumnGap }) => `${mobileRowGap}px ${mobileColumnGap}px`
    }
  }
}
